import { debounce } from 'lodash';

import {
  listCatalogProductsByDrugNameApi,
  listDrugApi,
  listDrugProfilesByDrugNameApi,
  upsertDrugProfileApi,
} from 'api/drug';
import { drugActions } from 'store/slices/drugSlice';

import { handleError } from './errorHandlerThunks';

export const loadDrugProfiles =
  ({ page }) =>
  (dispatch, getState) => {
    const { sortBy, filter } = getState().drugs.drugProfiles;
    dispatch(drugActions.updateCurrentPage({ page }));

    return listDrugApi({ page, sortBy, filter })
      .then(({ count, result }) => {
        dispatch(drugActions.loadDrugProfiles({ page, items: result, count }));
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const debouncedLoadDrugProfiles = debounce(({ dispatch }) => {
  return dispatch(loadDrugProfiles({ page: 1 })).finally(() =>
    dispatch(drugActions.setDrugListLoading(false))
  );
}, 1000);

export const updateDrugProfilesFilter =
  ({ filter }) =>
  (dispatch) => {
    dispatch(drugActions.setDrugListLoading(true));
    dispatch(drugActions.updateFilter({ filter }));
    debouncedLoadDrugProfiles({ dispatch });
  };

export const updateDrugProfileSortBy =
  ({ sortBy }) =>
  (dispatch) => {
    dispatch(drugActions.updateSortBy({ sortBy }));
    debouncedLoadDrugProfiles({ dispatch });
  };

export const upsertDrugProfile = (input) => (dispatch, getState) => {
  const { filter } = getState().drugs.drugProfiles;
  return upsertDrugProfileApi(input)
    .then((response) => {
      dispatch(updateDrugProfilesFilter({ filter }));
      return response;
    })
    .catch((error) => dispatch(handleError({ error })));
};

export const fetchDrugProfiles =
  ({ filter }) =>
  (dispatch) =>
    listDrugApi({ page: 1, filter })
      .then(({ result }) => result)
      .catch((error) => dispatch(handleError({ error })));

export const listDrugProfilesByDrugName = (drugName, filter) => (dispatch, getState) => {
  if (drugName === '' && getState().drugs.allDrugProfilesByDrugName.length > 0) {
    return Promise.resolve(getState().drugs.allDrugProfilesByDrugName);
  }

  return listDrugProfilesByDrugNameApi(drugName, filter)
    .then((drugProfiles) => {
      if (drugProfiles) {
        dispatch(drugActions.setAllDrugProfilesByDrugName(drugProfiles));
      }
      return drugProfiles;
    })
    .catch((error) => dispatch(handleError({ error })));
};

// POM-5705: catalog products for the "Associate to Catalog" reviewer popup. Kept as local modal
// state (no slice caching) — mirrors the StockManagement catalog-search pattern.
export const listCatalogProductsByDrugName = (drugName, strength) => (dispatch) =>
  listCatalogProductsByDrugNameApi(drugName, strength)
    .then((catalogProducts) => catalogProducts)
    .catch((error) => dispatch(handleError({ error })));
